/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React, { useState } from 'react';
import { object, string } from 'prop-types';
import { makeStyles, TextField } from '@material-ui/core';
import { useDispatch } from 'react-redux';

import validateEmailAddress from '../../../../../../helpers/validateEmailAddress';
import { emitCustomerIdentificationEvent } from '../../../../../../../state/ducks/TagManager/ducks/ClickStreamEvents/ClickStreamEvent-Actions';
import { setOfferInboxData } from '../../../../../../../state/ducks/App/App-Actions';

const useInputStyles = makeStyles((theme) => ({
    input: (styles) => ({
        margin: styles?.margin || '0 0 10px',
    }),
    emailField: {
        width: '100%',
    },
    phoneNumberField: {
        width: '100%',
    },
    form: {
        margin: '8px 0',
    },
}));

const InputField = ({
    data, offer, formId,
}) => {
    const classes = useInputStyles({
        margin: data?.margin,
    });

    const dispatch = useDispatch();
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');

    const campaignPayload = offer?.campaign?.campaignResponses?.[0]?.payload || {};

    const handleChange = (e) => {
        const inputValue = e.target?.value;
        if (data?.type === 'phone') {
            const regex = new RegExp(/^[0-9]+$|^$/);
            const isValid = regex.test(inputValue);

            if (isValid) {
                setPhoneNumber(inputValue);
            }
        } else {
            setEmail(inputValue.trim());
        }
    };

    const validateEmail = () => {
        const isValid = validateEmailAddress(email);
        if (isValid) {
            setError('');
            return true;
        }
        setError('Please enter a valid email address.');
        return false;
    };

    const validatePhoneNumber = () => {
        const isValid = (phoneNumber?.length >= 7) && (phoneNumber?.length <= 12);

        if (isValid) {
            setError('');
            return true;
        }
        setError('Please enter a valid phone number.');
        return false;
    };

    const handleSubscription = (isSuccessfull) => {
        const user = {};
        if (email) {
            user.email = email;
        }

        if (phoneNumber) {
            user.phone = phoneNumber;
        }

        if (isSuccessfull) {
            dispatch(emitCustomerIdentificationEvent({
                customEvent: {
                    eventDefinitionKey: campaignPayload?.eventDefinitionKey,
                    offerName: campaignPayload?.offerName,
                    offerDesc: campaignPayload?.offerDesc,
                    offerPercent: campaignPayload?.offerPercent,
                },
                page: 'home',
                salesforceResponse: offer,
                eventType: 'clickstream.customer-identification',
                eventSubType: 'journey-email-trigger',
                user,
            }));

            if (data?.type === 'email') {
                dispatch(setOfferInboxData({
                    offerGatewayOptin: true,
                    email,
                }));
            } else {
                dispatch(setOfferInboxData({
                    offerGatewayOptinSMS: true,
                    phone: phoneNumber,
                    phoneNumberSuccess: true,
                }));
            }
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (data?.type === 'phone' && !validatePhoneNumber()) {
            return;
        }

        if (data?.type === 'email' && !validateEmail()) {
            return;
        }

        handleSubscription(true);
    };

    switch (data?.type) {
        case 'email':

            return (
                <form onSubmit={handleSubmit} id={formId} className={classes.form}>
                    <div className={classes.input}>
                        <TextField
                            label={data?.label || 'Email'}
                            variant={data?.variant || 'outlined'}
                            type={data?.type || 'text'}
                            className={classes.emailField}
                            value={email}
                            id={data?.label || 'email'}
                            onChange={handleChange}
                            onBlur={validateEmail}
                            onFocus={() => setError('')}
                            error={!!error}
                            helperText={error}
                        />
                    </div>
                </form>
            );

        case 'phone':
            return (
                <form onSubmit={handleSubmit} id={formId} className={classes.form}>
                    <div className={classes.input}>
                        <TextField
                            label={data?.label}
                            variant={data?.variant || 'outlined'}
                            type="tel"
                            className={classes.phoneNumberField}
                            value={phoneNumber}
                            id={data?.label}
                            onChange={handleChange}
                            onBlur={validatePhoneNumber}
                            onFocus={() => setError('')}
                            error={!!error}
                            helperText={error}
                        />
                    </div>
                </form>
            );

        default:
            return null;
    }
};

InputField.propTypes = {
    data: object,
    offer: object,
    formId: string,
};
InputField.defaultProps = {
    data: {},
    offer: {},
    formId: '',
};

export default InputField;
